// extracted by mini-css-extract-plugin
export default {"emoji_message":"styles_emoji_message__tkaKP"};